import axios from 'axios';
import { handleError } from '@/_helpers/utils';
import { TALENTQ_STORE_NAMES } from '../constants';
import { PROJECT_ASSESSMENT_STORE_PREFIX } from './constants';

export default {
  namespaced: true,
  state() {
    return {
      created: false,
      loading: false,
      error: null,
      name: '',
      assessment_ids: []
    };
  },
  actions: {
    create(context) {
      if (context.state.loading) return Promise.resolve();
      context.commit('set_loading', true);
      context.commit('set_error', null);
      return axios
        .post(`/1.0/talentq/project`, context.getters.prepared_params)
        .then(response => response.data.data)
        .then(data => {
          context.commit(`vacancy_talentq/${TALENTQ_STORE_NAMES.PROJECT}/set_data`, data, {
            root: true
          });
          context.commit(`vacancy_talentq/${TALENTQ_STORE_NAMES.PROJECT_LIST}/add_item`, data, {
            root: true
          });
          context.commit('set_loading', false);
          return context.dispatch(
            `vacancy_talentq/${TALENTQ_STORE_NAMES.BINDING}/save_project`,
            data.id,
            { root: true }
          );
        })
        .catch(err => {
          err = handleError(err);
          context.commit('set_loading', false);
          context.commit('set_error', err);
          throw err;
        });
    },
    save(context) {
      if (context.state.loading) return Promise.resolve();
      context.commit('set_loading', true);
      context.commit('set_error', null);
      return axios
        .put(`/1.0/talentq/project/${context.getters.project_id}`, context.getters.prepared_params)
        .then(response => response.data.data)
        .then(data => {
          context.commit(`vacancy_talentq/${TALENTQ_STORE_NAMES.PROJECT}/set_data`, data, {
            root: true
          });
          context.commit(
            `vacancy_talentq/${TALENTQ_STORE_NAMES.PROJECT_LIST}/set_item_name`,
            {
              id: context.getters.project_id,
              name: data.name
            },
            { root: true }
          );
          context.commit('set_loading', false);
        })
        .catch(err => {
          err = handleError(err);
          context.commit('set_loading', false);
          context.commit('set_error', err);
          throw err;
        });
    },
    remove(context) {
      if (context.state.loading) return Promise.resolve();
      context.commit('set_loading', true);
      context.commit('set_error', null);
      return axios
        .delete(`/1.0/talentq/project/${context.getters.project_id}`)
        .then(() => {
          context.commit(
            `vacancy_talentq/${TALENTQ_STORE_NAMES.PROJECT_LIST}/remove_item`,
            context.getters.project_id,
            { root: true }
          );
          context.commit('set_loading', false);
          return context.dispatch(
            `vacancy_talentq/${TALENTQ_STORE_NAMES.BINDING}/save_project`,
            null,
            { root: true }
          );
        })
        .catch(err => {
          err = handleError(err);
          context.commit('set_loading', false);
          context.commit('set_error', err);
          throw err;
        });
    }
  },

  mutations: {
    set_loading(state, loading) {
      state.loading = loading;
    },
    set_error(state, error) {
      state.error = error;
    },
    set_created(state, created) {
      state.created = created;
    },
    set_name(state, name) {
      state.name = name;
    },
    set_assessment_ids(state, assessment_ids) {
      state.assessment_ids = assessment_ids;
    },
    add_assessment_id(state, assessment_id) {
      state.assessment_ids.push(assessment_id);
    },
    remove_assessment_id(state, assessment_id) {
      const pos = state.assessment_ids.indexOf(assessment_id);
      if (~pos) {
        state.assessment_ids.splice(pos, 1);
      }
    }
  },

  getters: {
    loading: state => state.loading,

    error: state => state.error,

    created: state => state.created,

    name: state => state.name,

    account_id: (state, getters, rootState, rootGetters) =>
      rootGetters[`vacancy_talentq/${TALENTQ_STORE_NAMES.ACCOUNT}/account_id`],

    project_id: (state, getters, rootState, rootGetters) =>
      rootGetters[`vacancy_talentq/${TALENTQ_STORE_NAMES.BINDING}/project_id`],

    assessment_ids: state => state.assessment_ids,

    form_assessments: (state, getters, rootState, rootGetters) =>
      getters.assessment_ids.map(assessment_id => ({
        ...rootGetters[PROJECT_ASSESSMENT_STORE_PREFIX + assessment_id + '/assessment'],
        id: assessment_id
      })),

    prepared_assessments: (state, getters) =>
      getters.form_assessments.map(assessment => {
        const prepared_assessment = { ...assessment };
        if (!prepared_assessment.saved) {
          delete prepared_assessment.id;
        }
        delete prepared_assessment.saved;
        return prepared_assessment;
      }),

    prepared_params: (state, getters) => {
      const prepared_params = {
        name: getters.name,
        account_id: getters.account_id,
        assessments: getters.prepared_assessments
      };
      if (getters.project_id) {
        prepared_params.project_id = getters.project_id;
      }

      return prepared_params;
    }
  }
};
